import axios from 'axios'
import axiosCancel from 'axios-cancel'


// redux
import store from '../redux/store';
import { logout } from '../redux/slices/userSlice';

// redux

// utilis
import {getToken, removeToken, error_alert, setToken} from "../utils"
// utilis
// constants
import {ACCESS_TOKEN, BASE_URL} from "../constants"

//any global headers go here.
let headers = {
    Accept: "application/json",

};

// create axios instance
export const Axios = axios.create({
    baseURL: BASE_URL + "/",
    headers: headers,
});

// check if we have a token and then append it to the axios instance
Axios.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    error => {
        Promise.reject(error);
    }
)

Axios.interceptors.response.use((response) => {
    return response
  }, function (error) {
    
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && originalRequest.url === 'api/auth/login'){
        return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        let maintoken = localStorage.getItem(ACCESS_TOKEN)
        maintoken = JSON.parse(maintoken)

        if(!maintoken.refresh_token){
            console.log("yahan without refresh")
            store.dispatch(logout());
            removeToken()
            error_alert("Your session expired! Please log in again to continue");
            return Promise.reject(error)
        }
        
        return axios.post(BASE_URL+'api/auth/refresh',
        {
            refresh: maintoken.refresh_token
        })
        .then(res => {
            if (res.status === 200) {
                console.log("helooo")
                maintoken.access_token = res.data.access
                maintoken.refresh_token = res.data.refresh
                    setToken(maintoken)
                    axios.defaults.headers['Authorization'] = "JWT " + res.data.access;
                    return Axios(originalRequest);
                }
            }).catch(e => {
            store.dispatch(logout());
            removeToken()
            error_alert("Your session expired! Please log in again to continue");
            return Promise.reject(error)
            })
    } else if (error.response && error.response.status === 401 && originalRequest._retry){
        store.dispatch(logout());
        removeToken()
        error_alert("Your session expired! Please log in again to continue");
        return Promise.reject(error)
    } 
    return Promise.reject(error)
    
    

    

    //old code below
    // const originalRequest = error.config;
    // if (error.response && error.response.status === 401){
    //     store.dispatch(logout());
    //     removeToken()
    //     error_alert(error.response.data.detail);
    //     return new Promise(() => { });
    // } else if (error.response && error.response.status === 403){
    //     store.dispatch(logout());
    //     removeToken()
    //     error_alert("Your session expired! Please log in again to continue");
    //     return new Promise(() => { });
    // }else {
    //     return Promise.reject(error);
    // }

}); 

// Using this because we might have to cancel requests
axiosCancel(Axios, {
    debug: false // default
})